export const GET_PRESCRIPTION_EXPLAINED = "GET_PRESCRIPTION_EXPLAINED";
export const GET_MEDICINE_STARTED = "GET_MEDICINE_STARTED";
export const GET_PRESCRIPTION_SUMMARY = "GET_PRESCRIPTION_SUMMARY";

// Answer List Types
export const GET_ANSWER_LIST_REQUEST = "GET_ANSWER_LIST_REQUEST";
export const GET_ANSWER_LIST_SUCCESS = "GET_ANSWER_LIST_SUCCESS";
export const GET_ANSWER_LIST_FAILURE = "GET_ANSWER_LIST_FAILURE";

// Add Followup Types
export const ADD_FOLLOWUP_REQUEST = "ADD_FOLLOWUP_REQUEST";
export const ADD_FOLLOWUP_SUCCESS = "ADD_FOLLOWUP_SUCCESS";
export const ADD_FOLLOWUP_FAILURE = "ADD_FOLLOWUP_FAILURE";

// Generate Followup ID Types
export const GENERATE_FOLLOWUP_ID_REQUEST = "GENERATE_FOLLOWUP_ID_REQUEST";
export const GENERATE_FOLLOWUP_ID_SUCCESS = "GENERATE_FOLLOWUP_ID_SUCCESS";
export const GENERATE_FOLLOWUP_ID_FAILURE = "GENERATE_FOLLOWUP_ID_FAILURE";

// Get Scheduled List Types
export const GET_SCHEDULED_LIST = "GET_SCHEDULED_LIST";
export const GET_SCHEDULED_LIST_REQUEST = "GET_SCHEDULED_LIST_REQUEST";
export const GET_SCHEDULED_LIST_SUCCESS = "GET_SCHEDULED_LIST_SUCCESS";
export const GET_SCHEDULED_LIST_FAILURE = "GET_SCHEDULED_LIST_FAILURE";

// Get Followup List Types
export const GET_FOLLOWUP_LIST_REQUEST = "GET_FOLLOWUP_LIST_REQUEST";
export const GET_FOLLOWUP_LIST_SUCCESS = "GET_FOLLOWUP_LIST_SUCCESS";
export const GET_FOLLOWUP_LIST_FAILURE = "GET_FOLLOWUP_LIST_FAILURE";

// Add Reminder Types
export const ADD_REMINDER_REQUEST = "ADD_REMINDER_REQUEST";
export const ADD_REMINDER_SUCCESS = "ADD_REMINDER_SUCCESS";
export const ADD_REMINDER_FAILURE = "ADD_REMINDER_FAILURE";

// Add Followup Delay Types
export const ADD_FOLLOWUP_DELAY_REQUEST = "ADD_FOLLOWUP_DELAY_REQUEST";
export const ADD_FOLLOWUP_DELAY_SUCCESS = "ADD_FOLLOWUP_DELAY_SUCCESS";
export const ADD_FOLLOWUP_DELAY_FAILURE = "ADD_FOLLOWUP_DELAY_FAILURE";

// Add Note Types
export const ADD_NOTE_REQUEST = "ADD_NOTE_REQUEST";
export const ADD_NOTE_SUCCESS = "ADD_NOTE_SUCCESS";
export const ADD_NOTE_FAILURE = "ADD_NOTE_FAILURE";

// Reset Notes
export const RESET_NOTES = "RESET_NOTES";

// Confirmed Add Followup Delay Types
export const CONFIRMED_ADD_FOLLOWUP_DELAY_REQUEST =
  "CONFIRMED_ADD_FOLLOWUP_DELAY_REQUEST";
export const CONFIRMED_ADD_FOLLOWUP_DELAY_SUCCESS =
  "CONFIRMED_ADD_FOLLOWUP_DELAY_SUCCESS";
export const CONFIRMED_ADD_FOLLOWUP_DELAY_FAILURE =
  "CONFIRMED_ADD_FOLLOWUP_DELAY_FAILURE";

// Confirmed Get Followup Delay List Types
export const CONFIRMED_GET_FOLLOWUP_DELAY_LIST_REQUEST =
  "CONFIRMED_GET_FOLLOWUP_DELAY_LIST_REQUEST";
export const CONFIRMED_GET_FOLLOWUP_DELAY_LIST_SUCCESS =
  "CONFIRMED_GET_FOLLOWUP_DELAY_LIST_SUCCESS";
export const CONFIRMED_GET_FOLLOWUP_DELAY_LIST_FAILURE =
  "CONFIRMED_GET_FOLLOWUP_DELAY_LIST_FAILURE";

export const CONFIRMED_ADD_REMINDER = "CONFIRMED_ADD_REMINDER";
export const CONFIRMED_ADD_REMINDER_SUCCESS = "CONFIRMED_ADD_REMINDER_SUCCESS";
export const CONFIRMED_ADD_REMINDER_FAILURE = "CONFIRMED_ADD_REMINDER_FAILURE";

export const CONFIRMED_GET_REMINDER_LIST = "CONFIRMED_GET_REMINDER_LIST";
export const CONFIRMED_GET_REMINDER_LIST_SUCCESS =
  "CONFIRMED_GET_REMINDER_LIST_SUCCESS";
export const CONFIRMED_GET_REMINDER_LIST_FAILURE =
  "CONFIRMED_GET_REMINDER_LIST_FAILURE";

export const CONFIRMED_GET_MEDICINE_STARTED = "CONFIRMED_GET_MEDICINE_STARTED";
export const CONFIRMED_GET_MEDICINE_STARTED_SUCCESS =
  "CONFIRMED_GET_MEDICINE_STARTED_SUCCESS";
export const CONFIRMED_GET_MEDICINE_STARTED_FAILURE =
  "CONFIRMED_GET_MEDICINE_STARTED_FAILURE";

export const CONFIRMED_GET_PRESCRIPTION_EXPLAINED =
  "CONFIRMED_GET_PRESCRIPTION_EXPLAINED";
export const CONFIRMED_GET_PRESCRIPTION_EXPLAINED_SUCCESS =
  "CONFIRMED_GET_PRESCRIPTION_EXPLAINED_SUCCESS";
export const CONFIRMED_GET_PRESCRIPTION_EXPLAINED_FAILURE =
  "CONFIRMED_GET_PRESCRIPTION_EXPLAINED_FAILURE";

export const CONFIRMED_GET_SERVICE_CALLER_SUMMARY =
  "CONFIRMED_GET_SERVICE_CALLER_SUMMARY";

export const CONFIRMED_GET_SERVICE_CALLER_SUMMARY_SUCCESS =
  "CONFIRMED_GET_SERVICE_CALLER_SUMMARY_SUCCESS";
export const CONFIRMED_GET_SERVICE_CALLER_SUMMARY_FAILURE =
  "CONFIRMED_GET_SERVICE_CALLER_SUMMARY_FAILURE";
